import { Auth } from 'aws-amplify';
import createAwsClient from 'agnostic-aws-signature';

const normalizeRedoItem = (item) => {
  if (!item || typeof item !== 'object' || Array.isArray(item)) {
    return null;
  }

  const media_key = item.media_key ?? item.mediaKey;
  if (!media_key) {
    return null;
  }

  return {
    id: item.pk_id,
    media_key,
    prompt: item.prompt ?? '',
  };
};

export const normalizeRedoResponse = (data) => {
  if (!data) {
    return [];
  }

  let items = [];

  if (Array.isArray(data.pending_redos)) {
    items = data.pending_redos;
  } else if (Array.isArray(data.pending_redo)) {
    items = data.pending_redo;
  } else if (data.pending_redo) {
    items = [data.pending_redo];
  }

  return items.map(normalizeRedoItem).filter(Boolean);
};

export const getFileNameFromMediaKey = (mediaKey) => {
  if (!mediaKey) {
    return '';
  }
  return mediaKey.split('/').pop();
};

export const getMediaTypeFromMediaKey = (mediaKey) => {
  const fileName = getFileNameFromMediaKey(mediaKey).toLowerCase();
  if (fileName.endsWith('.mp4') || fileName.endsWith('.webm')) {
    return 'video';
  }
  if (
    fileName.endsWith('.jpg') ||
    fileName.endsWith('.jpeg') ||
    fileName.endsWith('.png')
  ) {
    return 'photo';
  }
  if (fileName.endsWith('.m4a') || fileName.endsWith('.mp3')) {
    return 'audio';
  }
  return 'unknown';
};

export const getContentTypeFromMediaKey = (mediaKey) => {
  const fileName = getFileNameFromMediaKey(mediaKey).toLowerCase();
  if (fileName.endsWith('.png')) return 'image/png';
  if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) {
    return 'image/jpeg';
  }
  if (fileName.endsWith('.mp4')) return 'video/mp4';
  if (fileName.endsWith('.m4a')) return 'audio/m4a';
  return '';
};

export const getRedoModalMessage = (count) => {
  if (count === 1) {
    return 'You need to re-record a video or photo. This time, look at the camera and follow the prompts. Ready?';
  }
  return `You need to re-record ${count} videos or photos. This time, look at the camera and follow the prompts. Ready?`;
};

export const fetchPendingRedos = async (endpoint) => {
  const { accessKeyId, secretAccessKey, sessionToken } =
    await Auth.currentCredentials();
  const awsClient = createAwsClient(accessKeyId, secretAccessKey, sessionToken, {
    region: 'us-east-1',
    endpoint: endpoint + '/v3/student/files/redo',
  });
  const signedRequest = awsClient.signRequest({
    method: 'GET',
    headers: {
      accept: '*/*',
      'content-type': 'application/json',
    },
  });
  const response = await fetch(signedRequest.url, {
    headers: signedRequest.headers,
  });
  const data = await response.json();
  return normalizeRedoResponse(data);
};

export const completeRedo = async (endpoint, id) => {
  const { accessKeyId, secretAccessKey, sessionToken } =
    await Auth.currentCredentials();
  const awsClient = createAwsClient(accessKeyId, secretAccessKey, sessionToken, {
    region: 'us-east-1',
    endpoint: endpoint + '/v3/student/files/redo/' + id,
  });
  const signedRequest = awsClient.signRequest({
    method: 'PUT',
    headers: {
      accept: '*/*',
      'content-type': 'application/json',
    },
  });
  const response = await fetch(signedRequest.url, {
    method: 'PUT',
    headers: signedRequest.headers,
  });
  return response.ok;
};
